<template>
  <div class="jobs-create" v-loading="loading">
    <el-form>

      <el-form-item :label="`Название плана`">
        <date-picker
          type="month"
          default-panel="month"
          format="MMMM-YYYY"
          value-type="MMMM-YYYY"
          style="width: 100%"
          ref="datePicker"
          v-model="form.name"
        ></date-picker>
      </el-form-item>
      <el-form-item :label="`Примечание`">
        <el-input v-model="form.desc"/>
      </el-form-item>

      <div class="jobs-create__buttons">
        <el-button @click="close" v-if="!$route.params.id">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="!$route.params.id" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import work_units from '../../../data/work_units';
import DatePicker from 'vue2-datepicker';
import dayjs from "dayjs";
import 'vue2-datepicker/locale/ru';
import FilterSelect from "../../../components/FilterSelect";
import {getPlans} from "../../../firestore/plan";

export default {
  name: 'Create',
  props: ['lineId'],
  components: {FilterSelect, DatePicker},
  data() {
    return {
      loading: false,
      checked: true,
      createJoinInternal: false,
      options: {
        units: work_units.main,
        copy: []
      },
      plans: [],
      copyFrom: '',
      form: {
        name: '',
        desc: ''
      },
    };
  },

  async mounted() {
    if (this.$route.params.id) {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('plan')
        .doc(this.$route.params.id).get().then((response) => {
        const data = response.data();
        this.form = {
          ...data,
        };
      });
    }


    this.plans = await getPlans(this.$store.state.project.id)
    this.options.copy = this.plans.map((d) => ({
      label: d.name,
      value: d.id
    }));
  },

  methods: {
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
    close() {
      this.$router.go(-1);
    },
    edit() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('plan').doc(this.$route.params.id)
        .update({
          ...this.form,
        }).then((add) => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отредактировано',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      this.loading = true;

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('plan')
        .add({
          name: dayjs(this.form.name).format('MMMM-YYYY'),
          enabled: true,
          ...this.form,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Добавлено',
          type: 'success',
        });
        this.form = {
          name: '',
        };
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }).catch((error) => {
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 128px;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.joint {
  box-shadow: 0px 0px 8px 0px #ccc;
  background: #f7f7f7;
  padding: 10px 20px;
  border-radius: 5px;
}

.in-line {
  display: flex;
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.joint-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}

.li-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}

.link-block {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  margin-bottom: -26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Plan/Create.vue